import { render } from "./PageRegions.vue?vue&type=template&id=e0ea2c28"
import script from "./PageRegions.vue?vue&type=script&lang=js"
export * from "./PageRegions.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__